import { AxiosResponsePromise } from '@seiue/axios'
import { Card, State } from '@seiue/ui'
import {
  FieldDomainEnum,
  InformalReflection,
  InformalReflectionReq,
  fieldApi,
} from 'packages/sdks-next/growp'
import React from 'react'
import styled from 'styled-components'

import { FixedInfo } from './FixedInfo'
import { OtherInfoCard } from './OtherInfoCard'
import { UserDetailContext } from './context'
import { getInitFixedInfo } from './utils'

/**
 * 用户详情
 *
 * @param param - 参数
 * @param param.id - 用户id
 * @param param.domain - 用户所属域
 * @param param.data - 当前用户信息
 * @param param.updateInfo - 更新用户信息
 * @param param.isOwner - 是否是本人，本人则进行以下操作【1.隐藏状态 2.工号不能编辑 3.隐藏不可见的字段组字段】
 * @returns 学生详情
 */
export const UserDetail: React.FC<{
  id: number
  domain: FieldDomainEnum
  data?: InformalReflection | null
  updateInfo: ({
    id,
    payload,
  }: {
    id: number
    payload: InformalReflectionReq
  }) => AxiosResponsePromise<InformalReflection>
  isOwner?: boolean
}> = ({ id, domain, data, updateInfo, isOwner }) => {
  const { data: groupsData, loading } = fieldApi.useQueryFieldGroups({
    domain,
    query: { expand: ['fields'] },
  })

  if (!data || loading) return <State.Loading />
  return (
    <UserDetailContext.Provider
      value={{
        id,
        domain,
        groupsData,
        updateInfo,
      }}
    >
      <Card
        style={{ flexShrink: 0 }}
        contentStyle={{
          height: '160px',
          minWidth: '1200px',
          borderRadius: '12px',
          padding: '30px 20px 18px 20px',
          display: 'flex',
          justifyContent: 'flex-start',
        }}
      >
        <FixedInfo
          data={getInitFixedInfo(data)}
          isOwner={isOwner}
        />
      </Card>
      <BottomCard
        style={{ display: 'flex' }}
        contentStyle={{
          padding: '0 0',
          minWidth: '1200px',
          justifyContent: 'flex-start',
        }}
      >
        <OtherInfoCard
          data={data}
          isOwner={isOwner}
        />
      </BottomCard>
    </UserDetailContext.Provider>
  )
}

const BottomCard = styled(Card)`
  min-height: 350px;
`
